import React, { useState, useEffect } from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import "./../../styles/components/dashboard/pie-chart-padding.css";
import { COLORS } from "../../enums/pieChartColors";

function DgPieChart({ data, value, percentageInfo = 0, availableFundsPercentage = 0 }) {
  const [formattedData, setFormattedData] = useState([]);

  useEffect(() => {
    if (data) {
      // Map existing strategies
      const strategiesData = data.map((item) => ({
        name: item.strategyName,
        value: parseFloat(item[value]),
        type: 'strategy'
      }));

      // Add available funds if there are any
      const allData = [...strategiesData];
      if (availableFundsPercentage > 0) {
        allData.push({
          name: "Available Funds",
          value: parseFloat(availableFundsPercentage),
          type: 'available'
        });
      }

      setFormattedData(allData);
    }
  }, [data, availableFundsPercentage]);

  const onPieEnter = () => {};

  // Function to get color for each segment
  const getSegmentColor = (index, item) => {
    if (item.type === 'available') {
      return '#E5E7EB'; // Light gray for available funds
    }
    return COLORS[index % COLORS.length];
  };

  return (
    <>
      <div className="component pie-chart-padding">
        <div className="pie-wrapper">
          <PieChart width={180} height={260} onMouseEnter={onPieEnter}>
            <Pie
              data={formattedData}
              cx={90}
              cy={90}
              innerRadius={68}
              outerRadius={84}
              fill="#012B45"
              paddingAngle={10}
              dataKey={"value"}
              cornerRadius={40}
              stroke="none"
            >
              {formattedData.map((entry, index) => {
                const color = getSegmentColor(index, entry);
                return <Cell key={`cell-${index}`} fill={color} />;
              })}
            </Pie>
            <Tooltip
              content={({ payload }) => {
                return (
                  <div>
                    <div
                      style={{
                        position: "relative",
                        color: "#fff",
                      }}
                    />
                    <div
                      style={{
                        color: "#fff",
                        padding: "10px",
                        background: "#021c2d",
                        opacity: 0.96,
                        borderRadius: "20px",
                      }}
                    >
                      <b>{payload?.[0]?.payload?.name}</b>
                      <span className={""}>
                        <p>{payload?.[0]?.payload?.value}%</p>
                        {payload?.[0]?.payload?.type === 'available' && (
                          <p style={{ fontSize: '12px', opacity: 0.8 }}>
                            Risk Score: 0
                          </p>
                        )}
                      </span>
                    </div>
                  </div>
                );
              }}
            />
          </PieChart>
          <div className="pie-label">
            <div>
              <p className="percentage">
                {" "}
                {`${parseFloat(percentageInfo).toFixed(2)}%`}
              </p>
              <p className="percentage-total">Total</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DgPieChart;
